import { h } from "preact";
import { Route, Router } from "preact-router";

import Header from "./header";

// Code-splitting is automated for `routes` directory
import Home from "../routes/home";
import Profile from "../routes/profile";
import Landing from "../routes/landing";
import Analytics from "../routes/analytics";

const App = () => (
  <div id="app">
    <Header />
    <Router>
      <Route path="/" component={Home} />
      <Route path="/profile/" component={Profile} user="me" />
      <Route path="/landing/:user?" component={Landing} />
      <Route path="/profile/:user" component={Profile} />
      <Route path="/analytics/:user" component={Analytics} />
    </Router>
  </div>
);

export default App;
